import { useGetSearchParams } from '@/hooks/useGetSearchParams';
import { useReplaceSearchParams } from '@/hooks/useReplaceSearchParams';
import { useEffect, useState } from 'react';

export const useSearch = <
  TParams extends object = Record<string, string | undefined>,
  TKey extends keyof TParams & string = keyof TParams & string,
>(
  id: TKey
) => {
  const searchParams = useGetSearchParams<TParams>();
  const { replaceSearchParams } = useReplaceSearchParams<TParams>();

  const [search, setSearch] = useState('');

  useEffect(() => {
    const value = (searchParams?.[id] as string | undefined) ?? '';

    setSearch(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams?.[id]]);

  const clearSearch = () => {
    setSearch('');

    const update = { [id]: '' } as Partial<TParams>;

    replaceSearchParams({ ...update, page: null });
  };

  const submitSearch = () => {
    const update = { [id]: search } as Partial<TParams>;

    replaceSearchParams({ ...update, page: null });
  };

  return { search, setSearch, clearSearch, submitSearch, searchParams };
};
